import { render, staticRenderFns } from "./ProcedureBenefit.vue?vue&type=template&id=c5a117a6&scoped=true"
import script from "./ProcedureBenefit.vue?vue&type=script&lang=js"
export * from "./ProcedureBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a117a6",
  null
  
)

export default component.exports